/**
 * shellSession - who is at the screen, and what the roster opens with.
 *
 * Pure helpers for the top of the shell. Extracted from DeathWatchSimulator.
 */

/**
 * The roster's opening session. NOBODY, UNLESS A SCENARIO SAYS OTHERWISE
 * (v8.29.0): the app used to open with a "New Target" nobody asked for, and
 * an empty roster is what a GM setting up an ambush actually has. (Seeding
 * was once removed and put back in v8.28.0 - the pointer rule could not
 * tell "I added somebody" from "somebody else's roster arrived"; the
 * analysis is in the decisions log.) A fresh object per call.
 */
export function initialSessionOf(demoScenario) {
  return {
    tabs: demoScenario?.tabs ?? [],
    activeTab: demoScenario?.activeTab ?? null,
    atkProfiles: demoScenario?.atkProfiles,
  };
}

/**
 * This seat: whether it is the GM's, the session and player ids, and the
 * name on a ping's ring - the player's, not the combatant's: the name typed
 * at the session's door (`user.sessionName`, as presence and the vox read
 * it) before anything else. An email sign-in has no auth display name, so
 * every ping used to read "Someone" (Mission 6, 2026-10-20).
 */
export function seatOf(session, user) {
  return {
    isGm: session?.isGm || false,
    sessionId: session?.id,
    playerId: session?.playerId,
    displayName: user?.sessionName || session?.displayName || user?.displayName || 'Someone',
  };
}
